export interface IFilesToken {
  tokenValue: string;
  pathToFolder: string;
  pathToFile: string;
  dateIssued: number;
  expirationTime: number;
}

export class FilesToken implements FilesToken {
  tokenValue: string;
  pathToFolder: string;
  pathToFile: string;
  dateIssued: number;
  expirationTime: number;

  constructor(data: any) {
    this.tokenValue = typeof data.tokenValue === 'undefined' ? '#' : data.tokenValue;
    this.pathToFolder = typeof data.pathToFolder === 'undefined' ? '#' : data.pathToFolder;
    this.dateIssued = typeof data.dateIssued === 'undefined' ? 0 : data.dateIssued;
    this.pathToFile = typeof data.pathToFile === 'undefined' ? '#' : data.pathToFile;
    this.expirationTime = typeof data.expirationTime === 'undefined' ? 0 : data.expirationTime;
  }
}
